module.exports = __webpack_public_path__ + "static/media/zoom-in-icon.2eb889c4.svg";